import React, { useEffect } from "react";
import AIMethods from "components/AIMethods";
import { useState } from "react";
import { useAIContext } from "store/contexts/aiContext";
import MediaSummary from "components/MediaSummary";
import AIAssistanceResponseList from "components/AIAssistanceResponseList";
import { useToasts } from "react-toast-notifications";

function Summerizer() {
  const {
    aiOption,
    displayAIModal,
    formik,
    setDisplayAI,
    reSubmit,
    postSummaryOnTimeline,
    createTodoFromActionItems,
    allowTodo,
    sOption,
    isInnovationDashboard,
    isStatusPost,
  } = useAIContext();
  const { text, attachment } = formik.values;
  const [displaySelectionModal, setDisplaySelectionModal] = useState(false);
  const [mediaSummary, setMediaSummary] = useState(false);
  const [summaryQuery, setSummaryQuery] = useState(false);
  const { addToast } = useToasts();

  useEffect(() => {
    if (displayAIModal && aiOption === 2) {
      if (text && attachment) {
        setDisplaySelectionModal(true);
      } else if (text) {
        getMeetingSummaryFromText();
      } else if (attachment) {
        getMeetingSummaryFromMedia();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayAIModal, aiOption, reSubmit]);

  const getMeetingSummaryFromText = async () => {
    if (formik.values.text.length >= 50) {
      setSummaryQuery(formik.values.text);
    } else {
      addToast("Text should be minimum 50 to get Summarizer. ", {
        appearance: "error",
      });
    }
  };

  const hideSummaryQuery = () => {
    setSummaryQuery(false);
    setDisplayAI(false);
  };

  const getMeetingSummaryFromMedia = () => {
    setMediaSummary(true);
  };

  return (
    <div>
      {displaySelectionModal && (
        <AIMethods
          handleModal={() => setDisplaySelectionModal(false)}
          handleType={(type) => {
            if (type === 1) {
              getMeetingSummaryFromText();
            }
            if (type === 2) {
              getMeetingSummaryFromMedia();
            }
            setDisplaySelectionModal(false);
            setDisplayAI(false);
          }}
        />
      )}

      {mediaSummary && (
        <MediaSummary
          handleModal={() => setMediaSummary(false)}
          formik={formik}
          afterTranscribe={(content) => {
            formik.setFieldValue("text", content);
            formik.setFieldValue("attachment", null);
          }}
        />
      )}

      <AIAssistanceResponseList
        handleModal={hideSummaryQuery}
        open={summaryQuery}
        query={text}
        postonTimeline={(params) => postSummaryOnTimeline(params)}
        createTodo={createTodoFromActionItems}
        allowTodo={allowTodo}
        sOption={sOption}
        allowUpdate={!isInnovationDashboard}
        isStatusPost={isStatusPost ?? false}
      />
    </div>
  );
}

export default Summerizer;
